
import {defineComponent} from "vue"
import Message from "primevue/message";
import Header from "@/components/Header.vue";

export default defineComponent({
  name: "HomePage",
  components: {
    Header, Message
  },
  data() {
    return {
      showNotification: true as boolean, // Set manually to false to hide notification

    }
  },
  computed: {
    notification(): string {
      return this.$store.state.notification
    }
  },
  methods: {
    hideNotification() {
      this.showNotification = false
      setTimeout(() => this.showNotification = true, 5000)
      console.log("this.showNotification = false")
    }
  },
  mounted() {
    // initialize store with default language from user session
    let lang = this.$store.state.language
    this.$store.commit('setLang', lang)

  }
})
